import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      "clip-rule": "evenodd"
    }, [
      _createElementVNode("path", { d: "M5.077 5.926c0-1.537 1.263-2.783 2.82-2.783H12c.425 0 .77.34.77.759s-.345.76-.77.76H7.897c-.708 0-1.282.566-1.282 1.264V6.94c0 .419-.344.759-.769.759a.764.764 0 0 1-.77-.76zm.77 10.376c.424 0 .768.34.768.76v1.011c0 .7.574 1.266 1.282 1.266H12c.425 0 .77.34.77.759 0 .42-.345.76-.77.76H7.897c-1.557 0-2.82-1.247-2.82-2.785v-1.012c0-.419.344-.759.77-.759" }),
      _createElementVNode("path", { d: "M12.77 4.786c0-.881.89-1.492 1.727-1.186l5.128 1.874c.503.184.837.657.837 1.187v10.678c0 .53-.334 1.003-.837 1.187L14.497 20.4c-.838.307-1.728-.305-1.728-1.186zm2.26-2.61c-1.841-.674-3.8.671-3.8 2.61v14.428c0 1.939 1.959 3.284 3.8 2.61l5.13-1.874A2.785 2.785 0 0 0 22 17.34V6.66a2.785 2.785 0 0 0-1.84-2.61zM6.328 9.439a.776.776 0 0 1 1.088 0l2.051 2.024c.3.297.3.777 0 1.074L7.416 14.56a.776.776 0 0 1-1.088 0 .75.75 0 0 1 0-1.073l.738-.729H2.769C2.344 12.76 2 12.42 2 12s.344-.76.77-.76h4.296l-.738-.728a.75.75 0 0 1 0-1.073" })
    ], -1)
  ])))
}
export default { render: render }